export { default as BaseMenu } from './BaseMenu.vue'
export { default as EventModule } from './Event.vue'
export { default as Loading } from './Loading.vue'
export { default as Photoswipe } from './PhotoSwipe.vue'
